module.exports = __webpack_public_path__ + "img/illustrate.6747430a.svg";